module.exports = __webpack_public_path__ + "2256ee07c7a1a366e5bac1c3fcb8e216.ttf";


//////////////////
// WEBPACK FOOTER
// ./bower_components/footable/css/fonts/footable.ttf
// module id = 1219
// module chunks = 1